import BackendService from './BackendService';

export default class GroupService {
  static getGroups() {
    return BackendService.get('/dealerGroups');
  }

  static getGroup(groupId) {
    return BackendService.get(`/dealerGroups/${groupId}`);
  }

  static createGroup(group) {
    return BackendService.post('/dealerGroups', {
      body: group,
    });
  }

  static updateGroup(group) {
    return BackendService.put(`/dealerGroups/${group.id}`, {
      body: group,
    });
  }

  static deleteGroup(groupId) {
    return BackendService.delete(`/dealerGroups/${groupId}`);
  }
}
